module.exports = __webpack_public_path__ + "static/media/vacuum-robot.e2815480.svg";